import { render, staticRenderFns } from "./DashboardSkeletonCardList.vue?vue&type=template&id=effedf7c&scoped=true&"
import script from "./DashboardSkeletonCardList.vue?vue&type=script&lang=js&"
export * from "./DashboardSkeletonCardList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSkeletonCardList.vue?vue&type=style&index=0&id=effedf7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effedf7c",
  null
  
)

export default component.exports